import React from 'react';
import { Chip } from '@material-ui/core';

export interface SupplierCellProps {
    supplier: string;
    noSupplier?: boolean;
}

const SupplierCell: React.FC<SupplierCellProps> = ({ supplier, noSupplier }) => {
    const hasNoSupplier = noSupplier || !(supplier || '').toString().trim();
    if (hasNoSupplier) {
        return <Chip label="No supplier" size="small" color="default" />;
    }
    return <>{supplier || ''}</>;
};

export default React.memo(SupplierCell);
